import { useEffect } from 'react';
import { authService } from '../services/authService';
import { userService } from '../services/userService';
import { useAuthStore } from '../store/authStore';

export const useAuthListener = () => {
  const { setUser, clearUser } = useAuthStore();

  useEffect(() => {
    // Firebase 인증 상태 변경 감지
    const unsubscribe = authService.onAuthChange(async (user) => {
      if (user) {
        // 사용자가 로그인된 상태
        try {
          // Firestore에서 사용자 프로필 가져오기
          const userProfile = await userService.getUserDocument(user.uid);
          setUser(user, userProfile);
        } catch (err) {
          console.error('Error fetching user profile:', err);
          // 프로필을 못 가져와도 기본 인증 정보는 저장
          setUser(user, null);
        }
      } else {
        // 사용자가 로그아웃된 상태
        clearUser();
      }
    });

    // 컴포넌트 언마운트 시 리스너 해제
    return () => unsubscribe();
  }, [setUser, clearUser]);
};
